import React, { FC, ReactNode, useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { Dispatch } from 'redux';
import Header from '../Header/Header';
import Navigation from '../Navigation/Navigation';
import { DRAWER_WIDTH } from '../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { onLogout } from '../../store/UserSession/UserSessionActions';
import { GetString } from '../StringResourceManager';
import { fetchReferenceWeightsFilePath } from '../../store/ReferenceWeights/ReferenceWeightsActions';

// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      minHeight: `100vh`,
      background: theme.palette.background.paper,
      marginLeft: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(9) + 1,
      },
      backgroundColor: '#eceff1',
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: DRAWER_WIDTH,
    },
  }),
);

interface Props {
  toggleTheme: () => void;
  useDefaultTheme: boolean;
  children: ReactNode;
}

const Dashboard: FC<Props> = (
  { toggleTheme, useDefaultTheme, children },
  props: { instance: any },
) => {
  const classes = useStyles();
  const [open, toggle] = useState(true);

  const handleToggle = () => {
    toggle(open => !open);
  };

  const unauthorizedRequest: boolean = useSelector(
    (state: ApplicationState) => state.alertsReducer.unauthorizedRequest,
  );

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );

  const dispatch: Dispatch<any> = useDispatch();

  useEffect((): ReturnType<React.EffectCallback> => {
    if (unauthorizedRequest) {
      onLogout(dispatch);
    }
    return (): void => {};
  }, [unauthorizedRequest]);

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header
        open={open}
        handleMenuOpen={handleToggle}
        toggleTheme={toggleTheme}
        useDefaultTheme={useDefaultTheme}
        pageDisplayed={GetString('PAGE_TITLE_OVERVIEW')}
      />
      <Navigation open={open} handleMenuClose={handleToggle} />
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        {children}
      </main>
    </div>
  );
};

export default Dashboard;
